import { Order } from 'constants/interface';
import { OrderOtherStatusEnum, OrderProposalStatusEnum, OrderStatus } from 'constants/order';
import React from 'react';
import OrderOverview from '../OrderOverview';
import ProposalDetail from '../ProposalDetail';

interface OrderDisplayProps {
  order: Order
}

const OrderDisplay = ({
  order,
}: OrderDisplayProps): JSX.Element => {
  const proposalStatuses: OrderStatus[] = [
    ...Object.values(OrderProposalStatusEnum),
    OrderOtherStatusEnum.CANCELED,
  ];

  return proposalStatuses.includes(order.status)
    ? (
      <ProposalDetail
        order={order}
      />
    ) : (
      <OrderOverview
        order={order}
      />
    );
};

export default OrderDisplay;
